import { gql } from 'graphql-request';

export const collectionsGql = gql`
  productPageCollection {
    id
    _modelApiKey
    active: collectionActive
    name: collectionName
    prefix: collectionPrefix
    title: collectionTitle
  }
`;

export type TCollections = {
  id: string;
  _modelApiKey: string;
  active: boolean;
  name: string;
  prefix: string;
  title: string;
};
